<template>
    <FormModal :model="model" :init="init" modal-id="item" :beforeSaving="beforeSaving" :onSetIsEditMode="onSetIsEditMode" @save="$emit('save', $event)" @destroy="$emit('destroy', $event)">
        <template>
            <div :key="key" class="d-flex">
                <ItemBadges :model="model" class="mb-1" />
            </div>
        </template>
        <template v-slot:form="{ error: error }">
            <template v-if="model.is_edit_mode">
                <div data-v-2c619f04="" class="p-3 my-3 bg-light">
                    <strong data-v-2c619f04="">同期ON/OFF</strong>
                </div>
                <div class="d-flex justify-content-end">
                    <span class="mr-2">OFF</span>
                    <b-form-checkbox
                        v-model="model.status"
                        value="activated"
                        unchecked-value="suspended"
                        switch
                        >
                    </b-form-checkbox>
                    <span>ON</span>
                </div>
                <input-error :errors="error.status" />

                <div data-v-2c619f04="" class="p-3 my-3 bg-light">
                    <strong data-v-2c619f04="">在庫数マージン</strong>
                </div>
                <div class="d-flex justify-content-end">
                    <b-form-input v-model="model.margin" type="number" class="text-right" min="0"></b-form-input>
                </div>
                <p class="text-secondary"><small>全在庫数 − 在庫数マージンの数が同期されます。同期処理には時間差があるため、十分に大きな値にすると在庫切れを起こりにくくなります。</small></p>
                <input-error :errors="error.margin" />

                <div data-v-2c619f04="" class="p-3 my-3 bg-light">
                    <strong data-v-2c619f04="">詳細設定</strong>
                </div>
                <b-row>
                    <b-col>
                        <p><strong>Amazon</strong></p>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="3">
                        配送スピード
                    </b-col>
                    <b-col sm="9" class="text-right">
                        <b-form-radio-group
                            v-model="model.details.amazon.shipping_speed_category"
                            :options="[
                                { text: '通常配送', value: 'Standard', },
                                { text: 'お急ぎ便', value: 'Expedites', },
                                { text: '優先配送', value: 'Priority', },
                            ]"
                            button-variant="outline-secondary"
                            buttons
                            >
                        </b-form-radio-group>
                    </b-col>
                </b-row>
                <input-error :errors="error.data" />

                <div data-v-2c619f04="" class="p-3 my-3 bg-light">
                    <strong data-v-2c619f04="">同期対象</strong>
                </div>
                <b-row>
                    <b-col>
                        <h5>Inventory</h5>
                        <table class="table table-hover">
                            <tbody>
                                <tr v-if="model.user_item_caches.amazon">
                                    <td>
                                        <ItemDataAmazon :model="model.user_item_caches.amazon" :toggle-synced-switch="toggleSyncedSwitch" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>
                    <b-col>
                        <h5>Store</h5>
                        <table class="table table-hover">
                            <tbody>
                                <tr v-if="model.user_item_caches.ebay">
                                    <td>
                                        <ItemDataEbay :model="model.user_item_caches.ebay" :toggle-synced-switch="toggleSyncedSwitch" />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </b-col>
                </b-row>
                <input-error :errors="error.user_item_caches_id" />

                <div data-v-2c619f04="" class="p-3 my-3 bg-light">
                    <strong data-v-2c619f04="">候補</strong>
                </div>
                <b-row>
                    <b-col>
                        <h5>Inventory</h5>
                        <GridPage
                            ref="gridPageInventory"
                            :form-default="{
                            }"
                            :filters-default="{
                                provider: 'amazon',
                                quantity: '',
                                sort: 'name',
                            }"
                            :filter-items="[
                                {
                                    vModel: 'quantity',
                                    title: '在庫',
                                    options: [
                                        { text: '全て', value: '' },
                                        { text: 'あり', value: '1' },
                                        { text: 'なし', value: '0' },
                                    ],
                                },
                                {
                                    vModel: 'sort',
                                    title: '順番',
                                    options: [
                                        { text: '▲ 名前', value: 'name', },
                                        { text: '▼ 名前', value: '-name', },
                                        { text: '▲ 在庫', value: 'quantity', },
                                        { text: '▼ 在庫', value: '-quantity', },
                                    ],
                                },
                            ]"
                            filters-q-placeholder="Name, SKU, ASIN"
                            form-modal-id="item_cache"
                            search-action="item_cache/index"
                            :hide-add="true"
                            :row-clicked="false"
                            :filter-search-results="filterSearchResults"
                            >
                            <template v-slot:form="{ form, init }">
                            </template>

                            <template v-slot:column="{ item }">
                                <ItemDataAmazon :model="item" v-if="item.provider === 'amazon'" :toggle-synced-switch="toggleSyncedSwitch" />
                                <ItemDataEbay :model="item" v-if="item.provider === 'ebay'" :toggle-synced-switch="toggleSyncedSwitch" />
                            </template>
                        </GridPage>
                    </b-col>
                    <b-col>
                        <h5>Store</h5>
                        <GridPage
                            ref="gridPageStore"
                            :form-default="{
                            }"
                            :filters-default="{
                                provider: 'ebay',
                                quantity: '',
                                sort: 'name',
                            }"
                            :filter-items="[
                                {
                                    vModel: 'quantity',
                                    title: '在庫',
                                    options: [
                                        { text: '全て', value: '' },
                                        { text: 'あり', value: '1' },
                                        { text: 'なし', value: '0' },
                                    ],
                                },
                                {
                                    vModel: 'sort',
                                    title: '順番',
                                    options: [
                                        { text: '▲ 名前', value: 'name', },
                                        { text: '▼ 名前', value: '-name', },
                                        { text: '▲ 在庫', value: 'quantity', },
                                        { text: '▼ 在庫', value: '-quantity', },
                                    ],
                                },
                            ]"
                            filters-q-placeholder="Name, SKU, ASIN"
                            form-modal-id="item_cache"
                            search-action="item_cache/index"
                            :hide-add="true"
                            :row-clicked="false"
                            :filter-search-results="filterSearchResults"
                            >
                            <template v-slot:form="{ form, init }">
                            </template>

                            <template v-slot:column="{ item }">
                                <ItemDataAmazon :model="item" v-if="item.provider === 'amazon'" :toggle-synced-switch="toggleSyncedSwitch" />
                                <ItemDataEbay :model="item" v-if="item.provider === 'ebay'" :toggle-synced-switch="toggleSyncedSwitch" />
                            </template>
                        </GridPage>
                    </b-col>
                </b-row>
            </template>
        </template>
    </FormModal>
</template>

<script>
import { mapGetters } from 'vuex'
import FormModal from '@/components/FormModal.vue'
import ItemBadges from '@/components/ItemBadges.vue'
import ItemDataAmazon from '@/components/ItemDataAmazon.vue'
import ItemDataEbay from '@/components/ItemDataEbay.vue'
import InputError from '@/components/InputError.vue'
import GridPage from '@/components/GridPage.vue'

export default {
    components: {
        GridPage,
        FormModal,
        ItemBadges,
        InputError,
        ItemDataAmazon,
        ItemDataEbay,
    },
    emits: [
        'save',
        'destroy',
    ],
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return null
            },
        },
        init: {
            type: Function,
            default() {
                return null
            },
        },
    },
    data() {
        return {
            timer: null,
            key: 0,
        }
    },
    computed: {
        ...mapGetters([
            'auth_uuid',
            'trans',
        ])
    },
    mounted() {
//        this.timer = window.setInterval(this.interval, 10 * 1000)
//        this.interval()
    },
    destroyed() {
        clearInterval(this.timer)
    },
    methods: {
        toggleSyncedSwitch(item) {
            if (item.synced) {
                this.$set(this.model.user_item_caches, item.provider, item)
            } else {
                this.$delete(this.model.user_item_caches, item.provider)
            }
            this.interval()
        },
        filterSearchResults(response) {
            this.interval()
            return response
        },
        interval() {
            if (!this.model.user_item_caches) {
                return
            }

            this.setStateToggleSyncedSwitch()
        },
        getSkusToggleSyncedSwitch() {
            const skus = []
            const keys = Object.keys(this.model.user_item_caches)
            for (let i = 0; i < keys.length; i++) {
                skus.push(this.model.user_item_caches[keys[i]].provider + ':' + this.model.user_item_caches[keys[i]].sku)
            }
            return skus
        },
        getUuidsToggleSyncedSwitch() {
            const uuids = []
            const keys = Object.keys(this.model.user_item_caches)
            for (let i = 0; i < keys.length; i++) {
                uuids.push(this.model.user_item_caches[keys[i]].uuid)
            }
            return uuids
        },
        setStateToggleSyncedSwitch() {
            const uuids = this.getUuidsToggleSyncedSwitch()

            // synced
            const keys = Object.keys(this.model.user_item_caches)
            for (let i = 0; i < keys.length; i++) {
                this.$set(this.model.user_item_caches[keys[i]], 'synced', true)
            }

            // grid
            if (this.$refs.gridPageInventory.grid.response.data) {
                for (let i = 0; i < this.$refs.gridPageInventory.grid.response.data.hits.length; i++) {
                    this.$set(this.$refs.gridPageInventory.grid.response.data.hits[i], 'synced', uuids.indexOf(this.$refs.gridPageInventory.grid.response.data.hits[i].uuid) >= 0)
                }
            }
            if (this.$refs.gridPageStore.grid.response.data) {
                for (let i = 0; i < this.$refs.gridPageStore.grid.response.data.hits.length; i++) {
                    this.$set(this.$refs.gridPageStore.grid.response.data.hits[i], 'synced', uuids.indexOf(this.$refs.gridPageStore.grid.response.data.hits[i].uuid) >= 0)
                }
            }
        },
        beforeSaving (model) {
            let data = {}

            data.user_item_caches_id = this.getSkusToggleSyncedSwitch()

            return Object.assign(model, data)
        },
        onSetIsEditMode (model) {
            if (model.is_edit_mode) {
                if (model.images.length) {
                    setTimeout(() => {
                        this.fixImage(model.images[0])
                    }, 1000)
                }
            }
        },
    },
}
</script>

<style lang="scss" scoped>
.item-name {
    font-size: 1.6em;
    margin-bottom: 0;
}
.item-price {
    font-size: 1.6em;
    margin-bottom: 0;
}
</style>


